import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Form, Divider } from 'semantic-ui-react';
import FilteredMemberUserSelect from '../../../common/containers/FilteredMemberUserSelect';
import { firmAdmin, indirectMemberUser, investmentAdvisor, memberUser } from 'constants/userTypes';

const ALLOWED_TYPES = [
  memberUser,
  investmentAdvisor,
  indirectMemberUser,
  firmAdmin,
];

// Wrapper to adapt FilteredMemberUserSelect to redux-form Field
const ReduxFormFilteredMemberUserSelect = ({ input, multiple }) => (
  <FilteredMemberUserSelect
    allowedTypes={ALLOWED_TYPES}
    onChange={input.onChange}
    value={input.value}
    multiple={multiple}
    label="Users"
    placeholder="Email of user"
  />
);

const AddMemberUserContainer = () => (
  <Form>
    <div className="xwizard-form-group">
      <h4>Member Users</h4>
      <Divider />
      <Form.Group>
        <Field
          multiple
          component={ReduxFormFilteredMemberUserSelect}
          name="userIds"
        />
      </Form.Group>
    </div>
  </Form>
);

export default reduxForm({
  form: 'manage_member_user_for_member',
  enableReinitialize: true,
})(AddMemberUserContainer);
